import "./App.css";
import Home from "./routes/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivacyPolicy from "./routes/PrivacyPolicy";
import TestConnection from "./routes/TestConnection";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/teste-das-deusas" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/test-connection" element={<TestConnection />} />
      </Routes>
    </Router>
  );
}

export default App;
